<template>
  <loader v-bind="{ loading }">
    <columns class="is-mobile">
      <div class="column is-narrow">
        <pager button-class="is-rounded" v-if="events.data.length" :pageable="events" @nav="goTo" jump-controls/>
      </div>
      <column>
        <search-bar 
          v-model="filters.search"
          :searching="searching"
          @run-search="runSearch"
          @clear-search="clearSearch"/>
      </column>
    </columns>

    <columns>
      <column>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Event</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="event in events.data" :key="event.id">
              <td>{{ event.type }}</td>
              <td>{{ event.created_at | date('LLL') }}</td>
            </tr>
          </tbody>
        </table>
        <pager button-class="is-rounded" v-if="events.data.length" :pageable="events" @nav="goTo" jump-controls/>
      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  data: () => ({
    events: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.$bus.$emit('set-title', 'Events')
    this.loadItems()
  },

  methods: {
    loadItems() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({data}) => {
        this.events = data
        this.loading = false
        this.searching = false
      }, error => {
        console.log(error)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    runSearch() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.searching = true
      this.$router.push({
        name: 'environment-events',
        params: this.$route.params,
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environment-events',
        params: this.$route.params,
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadItems'
  }
}
</script>
